// extracted by mini-css-extract-plugin
export default {"container":"EmailChangePage_container__iJNfx"};